import { useEffect } from 'react';
import * as Logger from '@lib/Logger';

export const useLoggerContext = ({ userId }) => {
  useEffect(() => {
    if (userId) Logger.setUserId(userId);
  }, [userId]);
};
